/**
 * Bounds on a lane line's configured lane number.
 *
 * Mirrors `Shared.LaneNumbers` in TargetEnums.cs, which is the source of truth — keep the two in
 * step. The number doubles as a bit position in the device's `Lane` mask, so the ceiling is the
 * highest lane that enum declares. A value above it has no member to name it, and the firmware
 * conversion cannot represent it: the target ends up attributed to unrelated lanes. Validate before
 * saving rather than letting a layout reach a device unusable.
 */
export const LANE_NUMBER_MIN = 1;
export const LANE_NUMBER_MAX = 15;

export const isValidLaneNumber = (laneNumber: number | null | undefined): boolean =>
    typeof laneNumber === "number" &&
    Number.isInteger(laneNumber) &&
    laneNumber >= LANE_NUMBER_MIN &&
    laneNumber <= LANE_NUMBER_MAX;
